/**
 * 画面遷移
 */

/**
 * ページを別タブで開く
 * @param url 開くページのURL
 */
export function openInNewTab(url: string): void {
  window.open(url, '_blank', 'noopener,noreferrer');
}
